import React from 'react'
import styled from 'styled-components'
import {
  Title,
  Subtitle,
  ContainerFlexColumn,
  ContainerFlexRow,
} from './Utils/CustomClasses'

const WhatsIncluded = styled(ContainerFlexColumn)``

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  flex-wrap: wrap;
`

const CardBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 30%;
  min-width: 250px;
  max-width: 310px;

  gap: 25px;

  padding: 40px 30px;
  border-radius: 15px;
  border: 1px solid #e8e8e8;

  background: #fff;
  box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.08);

  img {
    width: 80px;
  }
`

const CardCustom = ({ image, title, text }) => {
  return (
    <CardBox>
      <img src={image} />
      <Title
        size="21px"
        sizemd="21px"
        sizesm="24px"
        weight="600"
        center
        dangerouslySetInnerHTML={{ __html: `${title}` }}
      />
      <Subtitle
        size="18px"
        sizemd="18px"
        sizesm="20px"
        weight="200"
        center
        dangerouslySetInnerHTML={{ __html: `${text}` }}
      />
    </CardBox>
  )
}

const WhatsIncludedGrid = ({ pageText, color }) => {
  return (
    <WhatsIncluded
      center
      padding="8vh 15vw 6vh 15vw"
      paddingSm="4vh 9vw 6vh 9vw"
      background={color}
    >
      <Title
        center
        color="#154549"
        margin="0 0 50px 0"
        size="32px"
        sizemd="32px"
        sizesm="28px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[65]}`,
        }}
      />
      <Subtitle
        center
        weight="300"
        color="#154549"
        size="22px"
        sizemd="22px"
        sizesm="22px"
        margin="0 0 50px 0"
        marginsm="0 8px 40px 8px"
        dangerouslySetInnerHTML={{
          __html: `${pageText[72]}`,
        }}
      />
      <CustomContainerFlexRow center gap="40px" gapMd="30px" rowMd>
        <CardCustom
          image="/images/how-it-works-v3/info-ic-1.svg"
          title={pageText[2]}
          text={pageText[3]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-2.svg"
          title={pageText[4]}
          text={pageText[5]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-3.svg"
          title={pageText[6]}
          text={pageText[7]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-4.svg"
          title={pageText[8]}
          text={pageText[9]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-5.svg"
          title={pageText[10]}
          text={pageText[11]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-6.svg"
          title={pageText[12]}
          text={pageText[13]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-14.svg"
          title={pageText[66]}
          text={pageText[67]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-13.svg"
          title={pageText[68]}
          text={pageText[69]}
        />
        <CardCustom
          image="/images/how-it-works-v3/info-ic-15.svg"
          title={pageText[70]}
          text={pageText[71]}
        />
      </CustomContainerFlexRow>
    </WhatsIncluded>
  )
}
export default WhatsIncludedGrid
